export const GROUP_ICONS = {
    1: 'flow flow-planting',
    2: 'flow flow-soil',
    3: 'flow flow-fertilizer',
    4: 'flow flow-storms',
    5: 'flow flow-bar-chart'
};

export const ALERT_ICONS = {
    1: 'mdi mdi-alert-circle info',
    2: 'mdi mdi-alert-circle warning',
    3: 'mdi mdi-alert-circle danger'
};

export const CULTURA_ICONS = {
    NAO_IDENTIFICADA: 'mdi mdi-help-rhombus',
    SOJA: 'flow flow-soy',
    MILHO: 'flow flow-corn',
    ALGODAO: 'flow flow-cotton',
    OUTROS: 'flow flow-leaf-second',
    null: 'mdi mdi-help-rhombus'
};
